import { render, staticRenderFns } from "./ShipmentWiseView.vue?vue&type=template&id=bbd60c9e&"
import script from "./ShipmentWiseView.vue?vue&type=script&lang=js&"
export * from "./ShipmentWiseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports